//import { defineCustomElement } from 'vue'


import AccountSummary from './components/AccountSummary.vue';
import ChangePassword from './components/ChangePassword.vue';
//import PageToolbar from './components/PageToolbar.vue';
//import SignInSignOut from './components/SignInSignOut.vue';
import UsageSummary from './components/UsageSummary.vue';
import SignUp from './components/SignUp.vue';
import WeatherCostCalculatorComponent from './components/WeatherCostCalculatorComponent.vue';
import CookiePreferences  from './components/CookiePreferences.vue';
//import ZendeskRedirect  from './components/ZendeskRedirect.vue';
import PriceList  from './components/PriceList.vue';
import AiAssistant from './components/website/AiAssistant.vue';
import AiApiAssistantWrapper from './components/loadermonitorwrappers/AiApiAssistantWrapper.vue';


// Import our custom CSS
import './scss/styles.scss'









let VcComponentLoader = (function(){
    console.log("Starting VcAccountComponentLoader..." );/*
    let language = document.getElementsByTagName("html")[0].getAttribute("lang");
    
    let i18n = createI18n({
        locale: language,
        fallbackLocale: 'en',
        //messages:VcAccountComponentMsgs
        
    })
    */

   
    const ACCOUNTCOMPONENTS={
        'ChangePassword':ChangePassword,
        'AccountSummary':AccountSummary,
        //'PageToolbar':PageToolbar,
        //'SignInSignOut':SignInSignOut,
        'SignUp':SignUp,
        'UsageSummary':UsageSummary,
        'WeatherCostCalculator':WeatherCostCalculatorComponent,
        'CookiePreferences':CookiePreferences,
        //'ZendeskRedirect':ZendeskRedirect,
        'PriceList':PriceList,
        'AiAssistant':AiAssistant,
        'AiApiAssistant':AiApiAssistantWrapper
    };

    window.VcAvailableComponents=(window.VcAvailableComponents && { ...window.VcAvailableComponents, ...ACCOUNTCOMPONENTS }) || ACCOUNTCOMPONENTS;
    /*
    let isReady=false;

    window.addEventListener("load",function(event) {
        isReady=true;

        attachComponents();
        
    },false);

    function attachComponents() {
        if (!window.VcComponents) {
            console.log("No VcComponents found..." );
            return;
        }

        window.VcComponents.forEach(item => {
            if (!window.VcAvailableComponents[item.component]) {
                console.log("Component not found..." +item.component);
                return;
            }
            console.log("Component being mounted..." +item.component);
            const app=createApp(window.VcAvailableComponents[item.component]); 
            app.use(i18n);
            app.mount(item.selector)
        });
    }
        */
})();



